import { get, post } from 'api/request';
import urls from 'configs/urls';

export const requestOTP = ({ data }) =>
  post(null, false, urls.accountManagementUrls.requestOTP, data);

export const signWithOTP = ({ data }) =>
  post(null, false, urls.accountManagementUrls.signWithOTP, data);

export const getLoginInfo = ({ headers }) =>
  get(headers, false, urls.accountManagementUrls.getLoginInfo);
